// extracted by mini-css-extract-plugin
module.exports = {"mortgage":"da51a739f7--mortgage--BkQvk","mortgage__title":"da51a739f7--mortgage__title--cYwAy","mortgage__banks":"da51a739f7--mortgage__banks--dkd_b"};